import { useMemo } from "react";
import { useQueryClient } from "react-query";
import { useParams } from "react-router-dom";
import API from "../../../services/API";
import { useContext } from "react";
import ToastContext from "../../../services/Context/ToastContext"
import useReorderSections from "./useReorderSections";
import { txt } from "../../../services/translation";

export default function useDeleteSection(){

    const {id} = useParams()

    const {setToast} = useContext(ToastContext)

    const queryClient = useQueryClient()

    const queryKey = useMemo(() => ['design', id, 'sections'], [id]);

    const reorderSections = useReorderSections()

    return (id) => {

        const ok = window.confirm(txt('confirmDeleteSection'));

        if(!ok) return false;

        const oldSections = [...queryClient.getQueryData(queryKey)];

        let newSections = [...queryClient.getQueryData(queryKey)].filter(c => c.id !== id);
        newSections = reorderSections(newSections)
        queryClient.setQueryData(queryKey, newSections);

        API.delete(`/design/sections/${id}`)
            .then(() => API.put('/design/sections/reorder', newSections))
            .catch(() => {
                queryClient.setQueryData(queryKey, oldSections)

                setToast({
                    severity: 'error',
                    message: txt('errorOccurred')
                })
            })
    }
}